import { defineMessages } from 'react-intl';

export default defineMessages({
    yourInfoTitle: {
        id: 'quoteandbind.farm.views.farm-confirmation.YourInfo',
        defaultMessage: 'Information'
    },
    yourHouseTitle: {
        id: 'quoteandbind.farm.views.farm-confirmation.YourHouse',
        defaultMessage: 'House'
    },
    yourCoveragesTitle: {
        id: 'quoteandbind.farm.views.farm-confirmation.YourCoverages',
        defaultMessage: 'Coverages'
    },
    yourCoveragesLimits: {
        id: 'quoteandbind.farm.views.farm-confirmation.Limits',
        defaultMessage: 'Coverages'
    },
    firstName: {
        id: 'quoteandbind.farm.views.farm-confirmation.FirstName',
        defaultMessage: 'First Name'
    },
    lastName: {
        id: 'quoteandbind.farm.views.farm-confirmation.LastName',
        defaultMessage: 'Last Name'
    },
    emailAddress: {
        id: 'quoteandbind.farm.views.farm-confirmation.Email',
        defaultMessage: 'Email'
    },
    coveragePremiumDetails: {
        id: 'quoteandbind.farm.views.farm-confirmation.Coverage Premium Details',
        defaultMessage: 'Coverage Premium Details'
    },
    baseCoverages: {
        id: 'quoteandbind.farm.views.policy-info.Base Coverages',
        defaultMessage: 'Base Coverages'
    },
    additionalCoverages: {
        id: 'quoteandbind.farm.views.policy-info.Additional Coverages',
        defaultMessage: 'Additional Coverages'
    },

    PolicyIssuanceAccepted : {
        id:'quoteandbind.farm.views.farm-confirmation.Policy Issuance Accepted',
        defaultMessage :'Policy Issuance Accepted'
    },

    confirmationMessage: {
        id: "quoteandbind.views.farm-confirmation.This policy has been approved",
        defaultMessage: "This policy has been approved. Your customer will receive an email confirmation shortly."
    }
});
